<div class="row">
	<div class="col">
		<div class="row">	
		Names on the site not unique
		<p>How would you prefer for people to see you on the site?</p>>
			
			<form class="col s12  text-blue-grey text-darken-4"
				(ngSubmit)="onSubmit()">
				<div class="row">
					<div class="input-filed col s12">
						<input [(ngModel)]="nick" id="nick" type="text" class="validate"><label
							for="nick">Nick</label>
					</div>
				</div>
				<button class="btn waves-effect waves-light indigo lighten-2"
					type="submit" name="action">.`-</button>
			</form>
		</div>
	</div>
</div>
